import React from 'react';

function CategoryCard({ category, image }) {
    return (
        <div className="card">
            <img src={image} alt={category} className="card-img-top" />
            <div className="card-body">
                <h5 className="card-title">{category}</h5>
                {/* Alte informații despre categorie */}
            </div>
        </div>
    );
}

export default CategoryCard;
